module.exports = __webpack_public_path__ + "img/spider_with_roller_skates.5d9a88d2.jpg";